<div class="sidebar included">
	<app-sidebar-header [title]="'Internet WiFi onboard'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>

		<div class="sidebar__header-image"
			[style.background-image]="'url(assets/images/ancillaries/includes/wifi-onboard.jpg)'"></div>
		<div class="flight">
			<div class="passenger" *ngFor="let passenger of passengers; let passenger_index = index">
				<div class="passenger__details" *ngIf="passenger.stops[0].added?.wifi.length>0">
					<h3 class="title-h3 passenger__name">
						{{TAP_printPassengerName(passenger)}}
					</h3>
				</div>
				<div class="passenger__actions">
					<div class="passenger__action" *ngFor="let voucher of passenger.stops[0].added?.wifi">
						<article class="ancillary-info-added-extra">
							<app-svg class="ancillary-info-added-extra__icon" svg="icons.svg#general--check" [alt]="'Added icon'">
							</app-svg>
							<div class="ancillary-info-added-extra__info">
								<h4 class="ancillary-info-added-extra__title"><span class="bold">{{ voucher.name }}</span> — added</h4>
								<span class="ancillary-info-added-extra__label">Voucher number</span>
								<p class="ancillary-info-added-extra__value" [tooltip]="'Copy number to clipboard'"
									[appCopyClipboard]="'UTWU-305-945-999'">UTWU-305-945-999</p>
							</div>
						</article>
					</div>
				</div>
			</div>
			<div class="sidebar-flight-text border">
				<h2 class="title-h2">WI-FI Stay connected in the sky</h2>
				<p>Our mobile and wi-fi services let you keep in touch with your company, family and friends by email,
					written messages and on social media.</p>
				<div class="sidebar-flight-text no-padding">
					<h4>Follow these steps to connect to our mobile network via Wi-Fi:</h4>
					<ul>
						<li>Activate the Wi-Fi on your device.</li>
						<li>Connect to Wi-Fi network.</li>
						<li>Open your browser and go to onboardwifi.flytap.com</li>
					</ul>
				</div>

				<div class="sidebar-flight-text ">
					<a href="javascript:;" class="link extras-feature__link link--external" target="_blank"
						aria-label="Open a dialog to wifi rules and restrictions, opens new window">All rules
						and
						restrictions</a>
				</div>
			</div>
			<div class="sidebar-flight-text">
				<button class="button " (click)="openWiFiSidebar()" aria-label="Open a dialog to add a wifi package.">Add
					WiFi</button>
			</div>
			<div class="extras__helper with-notification">
				<div class=""><a class="link extras-feature__link" aria-label="Close dialog" (click)="TAP_handleClose()"
						href="javascript:;" role="button">Close this
						window</a></div>
			</div>
		</div>
		<div #sidebar__footer class="sidebar__footer "></div>
	</div>
